module.exports = __webpack_public_path__ + "img/round-brown-wooden-5-piece-dining-set-in-room-1571463.2da066d7.jpg";